/** 中国大陆 11 位手机号（不含区号） */
export const CHINA_MOBILE_RE = /^1[3-9]\d{9}$/

/** E.164 数字长度范围 */
export const PHONE_DIGITS_MIN = 7
export const PHONE_DIGITS_MAX = 15

/** 格式不合法时的通用提示 */
export const PHONE_INVALID_MSG = '请输入正确手机号'

/** 短信下发：阿里云国际短信不支持号码中含空格 */
export const PHONE_NO_SPACE_MSG = '手机号不能包含空格，请去掉空格后重试'

/**
 * 提取手机号中的纯数字（去除 +、00 国际前缀、空格、短横线等）
 */
export function normalizePhoneDigits(value) {
  let s = String(value || '').trim()
  if (!s) return ''
  s = s.replace(/[\s\-().]/g, '')
  if (s.startsWith('+')) s = s.slice(1)
  else if (s.startsWith('00')) s = s.slice(2)
  return /^\d+$/.test(s) ? s : ''
}

function stripChinaCountryCode(digits) {
  if (digits.startsWith('86') && digits.length === 13) return digits.slice(2)
  return digits
}

/**
 * 校验手机号（兼容中国大陆及国际号码）
 * - 大陆：13800138000、+86 13800138000、008613800138000
 * - 国际：7~15 位数字（E.164）
 */
export function isValidPhone(value) {
  const digits = normalizePhoneDigits(value)
  if (!digits) return false
  if (CHINA_MOBILE_RE.test(digits)) return true
  const local = stripChinaCountryCode(digits)
  if (CHINA_MOBILE_RE.test(local)) return true
  return digits.length >= PHONE_DIGITS_MIN && digits.length <= PHONE_DIGITS_MAX
}

/** 原始输入是否含空白字符（含全角空格、不换行空格等） */
export function phoneHasWhitespace(value) {
  return /[\s\u00A0\u1680\u2000-\u200B\u202F\u205F\u3000\uFEFF]/.test(String(value ?? ''))
}

/**
 * 短信下发用手机号校验（阿里云国际短信不支持含空格；通过后返回纯数字 mobile 供接口使用）
 * @returns {{ ok: true, mobile: string } | { ok: false, message: string }}
 */
export function validatePhoneForSms(value) {
  const raw = String(value ?? '')
  if (!raw.trim()) return { ok: false, message: PHONE_INVALID_MSG }
  if (phoneHasWhitespace(raw)) return { ok: false, message: PHONE_NO_SPACE_MSG }
  const trimmed = raw.trim()
  if (!isValidPhone(trimmed)) return { ok: false, message: PHONE_INVALID_MSG }
  const mobile = normalizePhoneDigits(trimmed)
  if (!mobile) return { ok: false, message: PHONE_INVALID_MSG }
  return { ok: true, mobile }
}

/** 比较两个手机号是否相同（忽略区号前缀与格式差异） */
export function phonesEqual(a, b) {
  const da = normalizePhoneDigits(a)
  const db = normalizePhoneDigits(b)
  if (!da || !db) return false
  return stripChinaCountryCode(da) === stripChinaCountryCode(db)
}

/** 隐藏手机号中间部分（展示用） */
export function maskPhone(value) {
  const raw = String(value || '').trim()
  const digits = normalizePhoneDigits(raw)
  if (!digits) return raw
  if (digits.length >= 11) {
    return digits.replace(/^(\d{3})\d*(\d{4})$/, '$1****$2')
  }
  if (digits.length >= 7) {
    const head = Math.min(3, digits.length - 4)
    return digits.replace(new RegExp(`^(\\d{${head}})\\d*(\\d{4})$`), '$1****$2')
  }
  return raw
}
